export default __webpack_public_path__ + "static/media/CrabPage1.dc0a1dc8.txt";